<template>
  <div class="bg-box">
    <div style="display:flex;flex-direction: column;align-items: center;">
      <div class="stars">
        <object :data="svg"/>
      </div>
      <div class="frame">
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 610.45 540">
              <defs>
                <filter id="drop-shadow-1" filterUnits="userSpaceOnUse">
                  <feOffset dx="0" dy="7"/>
                  <feGaussianBlur result="blur" stdDeviation="8"/>
                  <feFlood flood-color="#bc6f00" flood-opacity=".75"/>
                  <feComposite in2="blur" operator="in"/>
                  <feComposite in="SourceGraphic"/>
                </filter>
              </defs>    
              <path class="cls-3" d="m456.26,498.59H158.98c-38.38,0-69.49-31.11-69.49-69.49V146.28c0-38.38,31.11-69.49,69.49-69.49h297.29c38.38,0,69.49,31.11,69.49,69.49v282.82c0,38.38-31.11,69.49-69.49,69.49"/>
              <path class="cls-2" d="m456.26,487.36H158.98c-38.38,0-69.49-31.11-69.49-69.49V135.05c0-38.38,31.11-69.49,69.49-69.49h297.29c38.38,0,69.49,31.11,69.49,69.49v282.82c0,38.38-31.11,69.49-69.49,69.49"/>
              <path class="cls-1" d="m449.1,474.17H166.14c-33.99,0-61.54-27.55-61.54-61.54V140.28c0-33.99,27.55-61.54,61.54-61.54h282.96c33.99,0,61.54,27.55,61.54,61.54v272.35c0,33.99-27.55,61.54-61.54,61.54"/>
              <path class="cls-7" d="m610.45,172.78c-7.98-.92-59.3-8.43-59.3-20.58,0-1.52.82-3.01,2.37-4.45-24.25,16.19-35.48,26.07-51.53,50.42-2.2,3.33-3.06,6.9-2.04,10.22.82,2.66,2.85,5.15,6.37,7.23,19.55,11.56,43.71,18.9,65.78,24.02,2.97-13.19,4.05-26.21,2.75-39.04,15.83-6.17,26.9-15.11,35.6-27.83"/>
              <path class="cls-4" d="m529.18,199.61c-6.75,4.55-31.3-3.58-29.23,8.78-1.02-3.32-.16-6.89,2.04-10.22,16.06-24.35,36.87-45.29,61.12-61.48-1.56,1.44-2.37,2.93-2.37,4.45,0,5.02,8.42,17.93,16.05,10.3-19.43,19.45-30.85,29.97-47.6,48.17"/>
              <path class="cls-5" d="m529.18,199.61c8.28-5.59,3.33-14.09-3.14-18.37-.49-.32-1-.65-1.54-.97-5.7-3.4-16.24-2.8-24.63-4.01-5.63-.81-9.87-2.03-11.97-7.99-4.07-11.52,38.02-43.17,57.04-64.75,15.47,4.95,29.28,10.72,41.04,17.15,3.11,1.7,5.14,4.34,5.99,7.78.85,3.44.29,6.72-1.66,9.68"/>
              <path class="cls-4" d="m517.12,159.5c-6.75,4.55-31.3-3.58-29.23,8.78-1.02-3.32-.16-6.89,2.04-10.22,16.06-24.35,36.87-45.28,61.12-61.48-1.56,1.44-2.37,2.93-2.37,4.45,0,5.02,8.36,9,18.73,12-14.19,18-31.17,33.71-50.28,46.47"/>
              <path class="cls-7" d="m0,172.78c7.98-.92,59.31-8.43,59.31-20.58,0-1.52-.82-3.01-2.37-4.45,24.25,16.19,35.48,26.07,51.54,50.42,2.2,3.33,3.06,6.9,2.04,10.22-.82,2.66-2.85,5.15-6.37,7.23-19.55,11.56-43.71,18.9-65.78,24.02-2.97-13.19-4.05-26.21-2.75-39.04-15.83-6.17-26.9-15.11-35.6-27.83"/>
              <path class="cls-4" d="m81.27,199.61c6.75,4.55,31.3-3.58,29.23,8.78,1.03-3.32.16-6.89-2.04-10.22-16.05-24.35-36.87-45.29-61.12-61.48,1.56,1.44,2.37,2.93,2.37,4.45,0,5.02-8.36,9-18.73,12,14.2,18,31.17,33.71,50.28,46.47"/>
              <path class="cls-5" d="m65.52,103.52c-15.47,4.95-29.28,10.72-41.04,17.15-3.11,1.7-5.14,4.34-5.99,7.78-.85,3.44-.29,6.72,1.66,9.68,16.06,24.35,36.87,45.29,61.12,61.48-8.28-5.59-3.34-14.09,3.14-18.37.49-.32,1.01-.65,1.54-.97,5.7-3.4,16.24-2.8,24.63-4.01,5.63-.81,9.87-2.03,11.97-7.99,4.07-11.52-38.02-43.17-57.03-64.75"/>
              <path class="cls-4" d="m93.33,159.5c6.75,4.55,31.3-3.58,29.23,8.78,1.02-3.32.16-6.89-2.04-10.22-16.06-24.35-36.87-45.28-61.12-61.48,1.56,1.44,2.37,2.93,2.37,4.45,0,5.02-8.36,9-18.73,12,14.2,18,31.17,33.71,50.28,46.47"/>
              <path class="cls-8" d="m570.6,78.18C512.19,36.97,415.11,10,305.23,10S98.26,36.97,39.86,78.18c-10.94,7.72-11.46,14.6-5.23,23.44,15.96,22.64,35.65,42.49,58.7,57.89-6.02-7.69-2-15.86,4.06-21.31,33.31-29.97,113.81-51.1,207.83-51.1s174.53,21.13,207.83,51.1c6.06,5.45,10.09,13.62,4.06,21.31,23.05-15.39,42.73-35.25,58.7-57.89,6.23-8.84,5.71-15.72-5.23-23.44"/>
              <defs>
              <path id="path1" class="cls-8" d="m97.39,138.2c33.31-29.97,113.81-51.1,207.83-51.1s174.53,21.13,207.83,51.1c6.06,5.45,10.09,13.62,4.06,21.31,23.05-15.39,42.73-35.25,58.7-57.89,6.23-8.84,5.71-15.72-5.23-23.44C512.19,36.97,415.11,10,305.23,10S98.26,36.97,39.86,78.18c-10.94,7.72-11.46,14.6-5.23,23.44,15.96,22.64,35.65,42.49,58.7,57.89-6.02-7.69-2-15.86,4.06-21.31"/> 
              </defs>
              <text fill="#ffbe4b" x="221.2" y="87.1" font-size="36" font-weight="bold" text-anchor="middle" transform="translate(0,-20)">
                <textPath xlink:href="#path1">{{title}}</textPath>
              </text>
              <text fill="#8d6aae" x="307.62" y="248.39" font-size="52" font-weight="bold" text-anchor="middle">{{text1}}</text>
              <text fill="#8d6aae" x="307.62" y="355.96" font-size="42" font-weight="bold" text-anchor="middle">{{text2}}</text>
              <path class="cls-6" d="m37.5,81.51C96.42,40.78,194.36,14.13,305.23,14.13s208.81,26.65,267.73,67.38c2.23,1.54,4.03,3.05,5.43,4.55-1.44-2.6-3.98-5.19-7.8-7.88C512.19,36.97,415.11,10,305.23,10S98.26,36.97,39.86,78.18c-3.81,2.69-6.36,5.28-7.8,7.88,1.4-1.5,3.2-3.01,5.43-4.55"/>
            </svg>
        <audio
            ref="audioRef"
            src="@/assets/vedio/hhs.mp3"
            autoplay
        ></audio>
            <div class="progress"></div>
            <div class="btn">
              <div class="single-btn">
                <button @click="$emit('close')">{{ $t("studentProgramme.answers2") }}</button>
              </div>
              <div class="single-btn" v-if="CanStartGacha">
                <button @click="onGacha">{{ $t("studentProgramme.startGacha") }}</button>
                <p style="color: #ffffff;">獲得1次抽卡機會了！</p>
              </div>
              <div class="single-btn">
                <button @click="leave">{{ $t("studentProgramme.leave") }}</button>
              </div>
            </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['answerResults', 'mode'],
  data() {
    return {
      svg: null,
      title:"",
      text1:"",
      text2:"",
      trueNum:0,
      allNum:0,
      CanStartGacha:false,
    };
  },
  methods: {
    onGacha() {
      const newPath = "/gacha";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    init() {
      this.trueNum = this.answerResults.correctQuantity
      this.allNum = this.answerResults.totalQuantity

      // 评估 assessments, 作业 work, 冒险(课题，小测) adventure, 图书馆(練習) library
      let { type, gradeId, isSmallTest } = this.$route.query,
      gradeList = ['', 'P1', 'P2', 'P3', 'P4', 'P5', 'P6'],
      probability = Number(this.trueNum/this.allNum * 100).toFixed(0),
      tips = {
        assessments: this.$t("studentProgramme.finishAssessments")+`（${gradeList[gradeId]}）`,
        work: this.$t("studentProgramme.finishWork"),
        adventure: this.$t("studentProgramme.finishAdventure"),
        library: this.$t("studentProgramme.finishLibrary"),
      }
      if(probability > 60){
        this.CanStartGacha=true;
      }
      if(isSmallTest == 'false') tips[type] = this.$t("studentProgramme.finishLibrary")

      this.title = tips[type];
      if(probability < 30) this.text1 = this.$t("studentProgramme.commend1");
      else if(probability > 80) this.text1 = this.$t("studentProgramme.commend2");
      else this.text1 = this.$t("studentProgramme.commend3");
      this.text2 = this.$t("studentProgramme.commend4")+`${this.answerResults.correctQuantity}/${this.answerResults.totalQuantity}`+this.$t("studentProgramme.question2");
      setTimeout(() => {
        document.body.style.setProperty('--progressWidth', probability + "%");
      }, 500);
    },
    leave() {
      // 评估 assessments, 作业 work, 冒险(课题，小测) adventure, 图书馆(練習) library
      let { type, isSmallTest } = this.$route.query

      // 处理类型  type=adventure&topicId=12&id=12&gradeId=1&isSmallTest=true
      if(isSmallTest != undefined) {
        type = isSmallTest == 'false' ? 'library' : 'adventure'
      }
      // 处理类型 
      if(isSmallTest != undefined) {
        if(isSmallTest == 'false') {
          type = 'library'
          window.sessionStorage.isSmallTest = "false";
        } else {
          type = 'adventure'
          window.sessionStorage.isSmallTest = "true";
        }
      }
      console.log(type, this.mode)
      // 提交过做题答案 且是adventure类型 triviaQuiz 为 "true" 其余情况都为false
      if(type == 'adventure' && this.mode == 'viewAnswer') {
        window.sessionStorage.triviaQuiz = "true";
      } else {
        window.sessionStorage.triviaQuiz = "false";
      }
      window.sessionStorage.isLoaded = "false";
      if(type == 'assessments') this.$router.push('/adventure');
      else this.$router.go(-1);
    }
  },
  created(){
    
  },
  mounted () {
    document.body.style.setProperty('--progressWidth', "0%");
    this.svg = require('@/assets/svg/results_bg_stars.svg')
    this.init()
  }
};
</script>

<style lang="scss" scoped>
.bg-box{
  display:flex;
  justify-content: center;
  position: fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
  background: #ffbe4b;
  z-index: 9;
  // z-index: 999999;
}
.stars{
  margin-top: 1.2vw;
margin-right: 1.5vw;
width:45.34vw;
// height: 25.24vw;
}
.frame{
  position:relative;
margin-top:-20.97vw;
text-align:center;
width:31.79vw;

.cls-1 {
  fill: #fff8db;
}
.cls-2 {
  fill: #fdf8ee;
}
.cls-3 {
  fill: #ddad6f;
  filter: url(#drop-shadow-1);
}
.cls-4 {
  fill: #4d3a84;
}
.cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {
  fill-rule: evenodd;
}
.cls-5 {
  fill: #7657a5;
}
.cls-6 {
  fill: #ab8ac1;
}
.cls-7 {
  fill: #6851a1;
}
.cls-8 {
  fill: #8d6aae;
}
.progress{
  margin:auto;
  width:20vw;
  height:1.25vw;
  background-color:#fff7d8;
  border-radius: 1.25vw;
  position: relative;
  &::after{
    content: '';
    position:absolute;
    top: 0.125vw;
    left: 0.125vw;
    bottom: 0.125vw;
    max-width: calc(100% - 0.25vw);
    width: var(--progressWidth, 0%);
    background-color:#845fa2;
    border-radius: 1.25vw;
    transition: width 1s linear 0s;
  }
}
.btn {
  width: 100%;
  display: flex;
  justify-content: center;

  .single-btn {
    margin: 0 1vw;
  }
}
button {
  width: 10vw;
  margin: auto;
  margin-top:2.16vw;
  color: #ffffff;
  background-color: #fa4c40;
  box-shadow: 0px 0.5vw 0 #df352a;
  border:none;
  border-radius: 1vw;
  font-size:1.5vw;
  padding:0.75vw 0;
  &:active{
    margin-top:2.66vw;
    box-shadow: 0px -0.5vw 0 #df352a;
  }
}
}
@media only screen and (max-width: 767px){
.bg-box{
  align-items: center;
}
.stars{
  width:90vw;
}
.frame{
  width:64.53vw;
  margin-top:-30.39vw;
  .progress{
    width:40.6vw;
  }
  button {
    width: 20vw;
    margin-top: 4.38vw;
    box-shadow: 0px 1.01vw 0 #df352a;
    &:active{
      margin-top: 5.39vw;
      box-shadow: 0px -1.01vw 0 #df352a;
    }
  }
}
}
</style>